<template>
    <div>
        <h3 class="h6 block-title border-bottom ps-0 mb-3">
            <i class="text-primary fa fa-fw fa-gift text-muted me-1"></i>
            Bons cadeau
        </h3>
        <div
            class="block-content block-content-full bg-body-light d-flex justify-content-between align-content-center rounded mb-3"
        >
            <input type="hidden" name="voucherArray" :value="JSON.stringify(vouchersUsed)" />
            <div class="d-flex flex-column w-100">
                <label class="form-label" for="voucher_code">Bon cadeau :</label>
                <input type="text" name="voucher_code" id="voucher_code" ref="voucherCode" class="form-control mb-3" />
                <div v-if="invalidVoucher && error != null" class="text-danger mb-3">{{ error }}</div>
                <div v-for="(item, i) in vouchersUsed" :key="i">
                    <div style="display: flex; flex-direction: row; justify-content: space-between">
                        <!-- <p class="text-success mb-3">
                            - Bon cadeau n°{{ item.code }}: {{ item.available_amount }}€ valable jusqu'au
                            {{ parseDate(item.date_end) }}
                        </p> -->
                        <p class="text-success mb-3">
                            - Bon cadeau n°{{ item.code }}:
                            {{ Number(item.available_amount).toFixed(2) }}€
                            disponible
                            ({{ Number(item.reserved_amount).toFixed(2) }}€ réservé)
                            valable jusqu'au
                            {{ parseDate(item.date_end) }}
                        </p>
                        <button type="button" @click="deleteBC(item)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
                <p v-if="voucherTotal > 0">Montant total de bon(s) cadeau {{ voucherTotal }}€ disponible</p>
                <div v-if="voucherBlocked" class="text-warning mb-3">Ce bon cadeau a été bloqué.</div>
                <div v-if="voucherAmountNull" class="text-warning mb-3">Ce bon cadeau a déjà été utilisé.</div>
                <button
                    type="button"
                    class="btn btn-primary align-items-center text-light  px-2"
                    v-on:click="handleVoucherCodeSearch()"
                >
                    Appliquer
                    <i class="fa fa-arrow-right opacity-50 ms-2"></i>
                </button>
            </div>
        </div>
        <div v-if="voucherArray.length > 0" class="block shadow-sm rounded">
            <div class="block-header">
                <h6 class="block-title">Montant à utiliser</h6>
            </div>
            <div class="block-content">
                <ul v-for="(item, i) in vouchersUsed" :key="i" class="p-0">
                    <li class="row">
                        <span class="col-12 col-md-4 d-flex align-items-center">
                            - Bon cadeau n°<b>{{ item.code }}</b>
                            :
                        </span>
                        <div class="col-12 col-md-8">
                            <div class="d-flex align-items-center">
                                <div class="input-group">
                                    <input
                                        type="number"
                                        class="form-control"
                                        min="0"
                                        placeholder="0"
                                        :max="voucherMaxAmount(item)"
                                        v-model="item.amount"
                                        @input="clampVoucherAmount(item)"
                                        @blur="clampVoucherAmount(item)"
                                    />
                                    <span class="input-group-text bg-primary text-light">€</span>
                                </div>
                                <span class="w-100 ms-2">/ {{ item.available_amount }}€</span>
                            </div>
                            <div
                                v-for="discount in voucherDiscountsFor(item)"
                                :key="`${item.id}-${discount.cartKey}`"
                                class="alert alert-info py-2 mt-2 mb-0"
                                role="status"
                            >
                                <i class="fa fa-tag me-1"></i>
                                Remise liée au bon cadeau sur {{ discount.prestationName }} :
                                <strong>-{{ formatAmount(discount.amount) }} €</strong>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import ApiManager from '../../Calendar/_core/ApiManager'
import { get, sync } from 'vuex-pathify'

export default {
    data: () => ({
        // voucher
        voucher: null,
        voucherArray: [],
        // voucherTotal: 0,
        voucherEntered: false,
        voucherApplied: false,
        voucherBlocked: false,
        invalidVoucher: false,
        voucherAmountNull: false,
        error: null,
        vouchersUsed: [],
    }),
    mounted() {
        this.getselectedVoucherItems()
    },
    computed: {
        ...sync('overlay@data', {
            c_payments: 'payments',
            c_voucherUsed: 'voucherUsed',
            c_cartItems: 'cartItems',
        }),
        ...get('overlay@data', {
            c_remainPrice: 'remainPrice',
            c_remainAfterGlobalPromoCode: 'remainAfterGlobalPromoCode',
        }),
        voucherTotal() {
            return this.vouchersUsed.reduce((total, voucher) => {
                return total + parseFloat(voucher.available_amount || 0)
            }, 0)
        },
        voucherPriceAlignmentDiscounts() {
            const usedCartItems = new Set()

            return this.vouchersUsed.flatMap(voucher => {
                const linkedItems = (voucher.items || []).filter(item =>
                    item.item_type === 'App\\Models\\Prestation\\Prestation' && this.toAmount(item.amount) > 0
                )
                const purchasedTotal = linkedItems.reduce((total, item) => total + this.toAmount(item.amount), 0)

                if (!linkedItems.length || this.toAmount(voucher.amount) + 0.009 < purchasedTotal) {
                    return []
                }

                const remainingCartItems = Object.entries(this.c_cartItems || {})
                    .filter(([cartKey, item]) => !usedCartItems.has(cartKey) && !item.pendingRemoval)
                const discounts = []
                const voucherCartKeys = []

                for (const linkedItem of linkedItems) {
                    const cartIndex = remainingCartItems.findIndex(([, item]) =>
                        item.options &&
                        item.options.type === linkedItem.item_type &&
                        Number(item.options.item_id) === Number(linkedItem.item_id)
                    )

                    if (cartIndex < 0) {
                        return []
                    }

                    const [cartKey, cartItem] = remainingCartItems.splice(cartIndex, 1)[0]
                    voucherCartKeys.push(cartKey)
                    const currentAmount = this.toAmount(cartItem.price) * this.toAmount(cartItem.qty || 1)
                    const discount = Math.max(0, Math.round((currentAmount - this.toAmount(linkedItem.amount)) * 100) / 100)

                    if (discount > 0) {
                        discounts.push({
                            voucherId: voucher.id,
                            cartKey,
                            prestationName: cartItem.name,
                            amount: discount,
                        })
                    }
                }

                voucherCartKeys.forEach(cartKey => usedCartItems.add(cartKey))

                return discounts
            })
        },
    },
    watch: {
        // voucherArray(newVal) {
        //     newVal.forEach(el => {
        //         if (!this.vouchersUsed.find(v => v.code == el.code)) {
        //             this.vouchersUsed.push({ id: el.id, code: el.code, amount: Math.min(this.c_remainPrice, el.available_amount), available_amount: el.available_amount, date_end:el.date_end })
        //         }
        //     })
        // },
        voucherArray(newVal) {
            newVal.forEach(el => {

                const realAvailableAmount =
                    Math.max(
                        0,
                        this.toAmount(el.available_amount) -
                        this.toAmount(el.reserved_amount)
                    )

                if (!this.vouchersUsed.find(v => v.code == el.code)) {

                    this.vouchersUsed.push({
                        id: el.id,
                        code: el.code,

                        amount: this.clampAmount(
                            Math.min(this.toAmount(this.c_remainPrice), realAvailableAmount),
                            realAvailableAmount
                        ),

                        available_amount: realAvailableAmount,

                        reserved_amount: el.reserved_amount,

                        date_end: el.date_end,

                        items: el.items || []
                    })
                }
            })
        },
        vouchersUsed: {
            handler(newVal) {
                newVal.forEach(item => this.clampVoucherAmount(item))
                this.c_voucherUsed = this.vouchersUsed;
                this.emitVoucherSummary()
            },
            deep: true,
        },
        c_cartItems: {
            handler() {
                this.emitVoucherSummary()
            },
            deep: true,
        },
    },
    methods: {
        toAmount(value) {
            const amount = parseFloat(String(value ?? 0).replace(',', '.'))

            return Number.isFinite(amount) ? amount : 0
        },
        formatAmount(value) {
            return this.toAmount(value).toFixed(2)
        },
        voucherDiscountsFor(voucher) {
            return this.voucherPriceAlignmentDiscounts.filter(discount => discount.voucherId === voucher.id)
        },
        emitVoucherSummary() {
            this.$emit('vouchers-update', {
                amount: this.vouchersUsed.reduce((total, voucher) => total + this.toAmount(voucher.amount), 0),
                alignmentDiscount: this.voucherPriceAlignmentDiscounts
                    .reduce((total, discount) => total + discount.amount, 0),
            })
        },
        voucherMaxAmount(item) {
            const currentVoucherCapacity = Math.max(
                0,
                this.toAmount(this.c_remainPrice) + this.toAmount(item.amount)
            )
            const capacityAfterOtherPayments = Math.max(
                0,
                this.toAmount(this.c_remainAfterGlobalPromoCode)
                    - this.nonVoucherPaymentsAmount()
                    - this.otherVouchersAmount(item)
            )
            const paymentCapacity = Math.min(
                currentVoucherCapacity || capacityAfterOtherPayments,
                capacityAfterOtherPayments
            )

            return Math.max(
                0,
                Math.min(
                    paymentCapacity,
                    this.toAmount(item.available_amount)
                )
            )
        },
        nonVoucherPaymentsAmount() {
            if (!this.c_payments) {
                return 0
            }

            return this.c_payments
                .filter(payment => payment.name !== 'Bon cadeau')
                .reduce((total, payment) => total + this.toAmount(payment.value), 0)
        },
        otherVouchersAmount(currentItem) {
            return this.vouchersUsed
                .filter(item => item.id !== currentItem.id)
                .reduce((total, item) => total + this.toAmount(item.amount), 0)
        },
        clampAmount(value, max) {
            const amount = this.toAmount(value)
            const capped = Math.min(Math.max(amount, 0), Math.max(0, this.toAmount(max)))

            return Math.round(capped * 100) / 100
        },
        clampVoucherAmount(item) {
            if (item.amount === '' || item.amount === null || item.amount === undefined) {
                return
            }

            const capped = this.clampAmount(item.amount, this.voucherMaxAmount(item))

            if (this.toAmount(item.amount) !== capped) {
                item.amount = capped
            }
        },
        async getselectedVoucherItems() {
            await ApiManager.getselectedVoucherItems(0).then(res => {
                if (res.data != 0) {
                    res.data.forEach(element => {
                        this.handleVoucherCodeSearch()
                    })
                }
            })
        },
        handleVoucherCodeSearch() {
            // this.$refs.voucherCode.value = 7755872296
            //console.log('rzea')

            if (this.$refs.voucherCode.value !== '') {

                axios
                    .get(`/back-office/voucher/check-code`, {
                        params: { code: this.$refs.voucherCode.value },
                    })
                    .then(res => {
                        // Si le code est invalide
                        console.log(res.data)
                        if (!res.data || Object.keys(res.data).length === 0) {
                            this.voucherApplied = false
                            this.voucher = null
                            this.voucherAmountNull = false
                            this.invalidVoucher = true
                        } else {
                            if (typeof res.data === 'string') {
                                this.invalidVoucher = true
                                this.voucherApplied = false
                                this.voucher = null
                                this.voucherAmountNull = false
                                this.error = res.data
                            } else {
                                if (
                                    !this.voucherArray
                                        .map(e => {
                                            if (e.id == res.data.id) return false
                                        })
                                        .includes(false)
                                ) {
                                    this.voucherArray.push(res.data)
                                    // this.voucherTotal += res.data.available_amount
                                    // this.voucherTotal +=
                                    //     parseFloat(res.data.available_amount || 0) -
                                    //     parseFloat(res.data.reserved_amount || 0)
                                    document.getElementById('voucher_code').value = ''
                                }
                                this.voucher = res.data
                                if (this.voucher.is_blocked) {
                                    this.voucherBlocked = true
                                    this.invalidVoucher = false
                                    this.voucherApplied = false
                                    this.voucherAmountNull = false
                                } else if (this.voucher.available_amount == 0) {
                                    this.voucherBlocked = false
                                    this.invalidVoucher = false
                                    this.voucherApplied = false
                                    this.voucherAmountNull = true
                                } else {
                                    this.invalidVoucher = false
                                    this.voucherApplied = true
                                    this.voucherAmountNull = false
                                    this.voucherBlocked = false
                                }
                            }
                        }
                    })
                    .catch(err => {
                        this.invalidVoucher = true
                        this.voucherApplied = false
                        this.voucher = null
                        this.voucherAmountNull = false
                        this.error = err.response.data['message']
                    })
            } else {
                this.currentVoucher = null
            }
        },
        parseDate(date) {
            moment.locale('fr')
            return moment(date).format('DD/MM/YYYY')
        },

        deleteBC(e) {
            const isLargeNumber = element => element.id == e.id
            const voucherToDelete = this.voucherArray.find(isLargeNumber)
            const index = this.voucherArray.findIndex(isLargeNumber)
            if (index > -1) {
                this.voucherArray.splice(index, 1)
                // this.voucherTotal -= e.available_amount
                this.vouchersUsed.splice(
                    this.vouchersUsed.findIndex(v => v.code == voucherToDelete.code),
                    1
                )
            }
        },
    },
}
</script>

<style></style>
